export default __webpack_public_path__ + "static/media/advantage-list-2.5e7acd0c.jpg";